module.exports = __webpack_public_path__ + "img/Payment-Redsys.f4385b16.jpg";